import React from 'react';

import AbstractComponent from "components/Abstract";
import MenuItemsComponent from "components/MenuItems";

import './index.less';
import './themes/default.less';

import { ReactComponent as CloseMenuIcon } from 'icons/close.svg';

export default class MenuPopup extends AbstractComponent {

    renderVersion() {
        const { version } = globalThis.packageInfo;
        const date = this._helper.date.toDateTimeStr(new Date(document.lastModified));

        return (
            <div className="version flex centerAll pad8">
                <div className="text p1SemiBold">{this.tr("main.version")}</div>
                <div className="text p1">{`: ${version}`}</div>
                <div className="text p2 date">{`${this._helper.string.spaceChar}(${date})`}</div>
            </div>
        );
    }

    renderLangs() {
        return (
            <div className="langs flex centerH gap8">
                {this._config.langs.map(key => {
                    const active = this._helper.currentLanguage === key ? "active" : "hand";

                    return (
                        <div
                            key={key}
                            className={`lang ${active}`}
                            onClick={this.changeLanguage.bind(this, key)}>
                            {key}
                        </div>
                    );
                })}
            </div>
        );
    }

    render() {
        const opened = this.props.opened ? " active" : "";
        const { pages } = this._config;

        return (
            <div
                className={`menuPopup${opened} pos fixed flex col`}
                onClick={this._helper.stopEvent.bind(null)}
            >
                <div className="top flex centerV">
                    <CloseMenuIcon className="close hand" onClick={this.props.toggleMenu.bind(this)} />
                    {this.insertLogo()}
                </div>
                <MenuItemsComponent
                    className="items flex1 flex col"
                    menuItems={pages}
                    showLabel={true}
                    value={this.currPage()}
                />
                {this.renderVersion()}
                {this.renderLangs()}
            </div>
        );
    }
}
